import { CourseProgressFlow } from "types";
import { getFlowImageUrl } from "utils/courseImagePreload";
import { CourseCover } from "./coursePresentation";

export function LessonThumbnail({ flow }: { flow: CourseProgressFlow }) {
  const details = flow.flow_details;

  return (
    <div
      className="lesson-thumbnail"
      data-testid={`lesson-thumbnail-${details.id}`}
      aria-hidden="true"
    >
      <CourseCover
        courseId={details.id}
        name={details.title?.trim() || details.name}
        source={getFlowImageUrl(flow)}
        small
      />
    </div>
  );
}
